<main class="sd-app relative min-h-screen">
  <div class="sd-lang-switch" *ngIf="showLanguageSwitch">
    <label class="sr-only" for="sd-lang-select">Language</label>
    <select
      id="sd-lang-select"
      class="sd-lang-switch__select"
      (change)="switchLang($event)"
    >
      <option
        [value]="language.code"
        [selected]="language.code == selectedLanguage"
        *ngFor="let language of languages"
      >
        {{ language.name | translate | titlecase }}
      </option>
    </select>
  </div>
  <router-outlet></router-outlet>
</main>
